import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import {
    Row,
    Col,
    Card
} from "antd";
import { FinancialYearSelector } from "components";
import AutoComputedRatioList from "./auto-computed-ratios";
import FinancialAnalysisForm from "./financial-analysis-form";
import {
    createdFinancialYear,
    fetchFinancialYears,
    fetchFinancials,
    updateFinancials,
} from "store/actions";

import "styles/financial-analysis-table.css";
import { STATE_STATUS } from "constants/index";
import { FinancialDetailRecord } from "records/index";

class CompanyFinancialAnalysisTab extends React.Component {
    state = {
        year: null,
        yearBefore: null
    };
    f1 = null;
    f2 = null;
    handleFinancialYearsFetch() {
        if (this.props.financialYearsStatus === STATE_STATUS.UNFETCHED) {
            this.props.fetchFinancialYears(this.props.companyId);
        }
    }
    handleFinancialsFetch() {
        if (
            !this.props.financialsStatus ||
            this.props.financialsStatus === STATE_STATUS.UNFETCHED
        ) {
            this.props.fetchFinancials(this.props.companyId);
        }
    }
 
    componentDidMount() {
        this.handleFinancialYearsFetch();
        this.handleFinancialsFetch();
    }
    componentDidUpdate() {
        this.handleFinancialYearsFetch();
        this.handleFinancialsFetch();
    }
   
  
    handleFinancialsSelect(year, yearBefore) {
        if (this.props.financialsStatus === STATE_STATUS.FETCHED && year) {
            const f1 = this.props.financials.find(
                _ => _.financial_year.id == (year && year.id)
            );
            const f2 = this.props.financials.find(
                _ => _.financial_year.id == (yearBefore && yearBefore.id)
            );
            this.f1 =
                f1 ||
                new FinancialDetailRecord({
                    case: null,
                    company: this.props.companyId,
                    financial_year: year,
                    is_active: true
                });
            this.f2 =
                f2 ||
                new FinancialDetailRecord({
                    case: null,
                    company: this.props.companyId,
                    financial_year: yearBefore,
                    is_active: true
                });
        }
    }
    onFinancialYearSelect = (year, yearBefore) => {
        if (year === "disable") {
            this.setState({
                year: null,
                yearBefore: null
            });
            return;
        }
        this.setState({
            year,
            yearBefore
        });
    };
    save = (f1, f2) => {
        let is_f1_found = false,
            is_f2_found = false;
        let financials = this.props.financials.map(_ => {
            if (f1.id === _.id) {
                is_f1_found = true;
                return f1.set("is_active", true);
            }
            if (f2.id === _.id) {
                is_f2_found = true;
                return f2.set("is_active", true);
            }
            return _.set("is_active", false);
        });
        if (!is_f1_found) {
            financials = financials.push(f1.set("is_active", true));
        }
        if (!is_f2_found && f2.financial_year) {
            financials = financials.push(f2.set("is_active", true));
        }
        this.props.updateFinancials(this.props.companyId, financials.toArray());
    };
    render() {
        this.handleFinancialsSelect(this.state.year, this.state.yearBefore);
        return (
            <React.Fragment>
                <Row className={"p-5"}>
                    <Col
                        span={12}
                        className={"d-flex justify-content-space-between p-10"}
                    >
                        <h2> Financial Years </h2>
                    </Col>
                    <Col
                        span={12}
                        className={"d-flex justify-content-space-between p-10"}
                    >
                        <FinancialYearSelector
                            financialYears={this.props.financialYears}
                            onFinancialYearSelect={this.onFinancialYearSelect}
                            year={this.state.year}
                            disabled={!this.state.year}
                            isRiskApprover={this.props.isRiskApprover}
                        />
                    </Col>
                    <Col span={16} className={"p-10"}>
                        <Row className={"p-5"}>
                            <Col span={24} className={"p-10"}>
                                <FinancialAnalysisForm
                                    formName="TradingProfitAndLoss"
                                    f1={this.f1}
                                    f2={this.f2}
                                    save={this.save}
                                    title={"Trading Profit and Loss"}
                                    recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                                />
                            </Col>
                            <Col span={24} className={"p-10"}>
                                <FinancialAnalysisForm
                                    formName="BalanceSheetLiabilitiesForm"
                                    f1={this.f1}
                                    f2={this.f2}
                                    save={this.save}
                                    title={"Balance Sheet Liabilities"}
                                    recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                                />
                            </Col>
                            <Col span={24} className={"p-10"}>
                                <FinancialAnalysisForm
                                    formName="BalanceSheetAssetsForm"
                                    f1={this.f1}
                                    f2={this.f2}
                                    save={this.save}
                                    title={"Balance Sheet Assets"}
                                    recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={8} className={"p-10"}>
                        <Row className={"p-5"}>
                            <Col span={24} className={"p-10"}>
                                <Card className={"padless-card mb-10"}>
                                    <AutoComputedRatioList
                                        name="ratios"
                                        f1={this.f1}
                                        f2={this.f2}
                                    />
                                </Card>
                            </Col>
                            <Col span={24} className={"p-10"}>
                                <Card className={"padless-card"}>
                                    <AutoComputedRatioList
                                        name="dscr"
                                        f1={this.f1}
                                        f2={this.f2}
                                    />
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}

CompanyFinancialAnalysisTab.propTypes = {
    companyId: PropTypes.number,
    financialYearsStatus: PropTypes.string,
    financialYears: PropTypes.object,
    financialsStatus: PropTypes.string,
    financials: PropTypes.object,
    createdFinancialYear: PropTypes.func,
    fetchFinancialYears: PropTypes.func,
    updateFinancials: PropTypes.func,
    fetchFinancials: PropTypes.func,
    isRiskApprover: PropTypes.bool,
    recreditViewOnlyPermission: PropTypes.bool,
};

CompanyFinancialAnalysisTab.defaultProps = {
    isRiskApprover: false
};

const mapStateToProps = (state, props) => ({
    financialYearsStatus: state.financials.get("financialYearsStatus"),
    financialYears: state.financials.get("financialYears"),
    financialsStatus: state.financials.getIn([
        "list",
        props.companyId,
        "status"
    ]),
    financials: state.financials.getIn(["list", props.companyId, "data"])
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            createdFinancialYear,
            fetchFinancialYears,
            updateFinancials,
            fetchFinancials
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CompanyFinancialAnalysisTab);
